import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useParams } from 'react-router-dom';
import ContentContainer from '~/src/components/ContentContainer';
import Layout from '~/src/components/Layout';
import PageHeader from '~/src/components/PageHeader';
import Table from '~/src/components/Standings/Table';
import styles from '~/src/lib/styles.json';
import { imgIconGoldenTicketSvg, imgIconStandingsBracketSvg, imgIconStandingsListSvg } from '../../images';
import { Urls } from '../../lib/enums/urls';
import { Ot7Division } from '../../models/Ot7Division';
import useFetch from '../../overtime-lib/src/www/hooks/useFetch';
import NotFound from '../NotFound';
import GoldenTicketBracket from '../Standings/GoldenTicketBracket';
import PlayoffsBracket from '../Standings/PlayoffsBracket';
import Playoffs from './Playoffs';
import PowerRankings from './PowerRankings';
import './Standings.scss';

const Header = ({ ot7_divisions }: { ot7_divisions: Ot7Division[] }) => {
	const playoffsTab = ['playoffs', 'Playoffs'];
	const powerRankingsTab = ['power-rankings', 'Power Rankings'];
	const divisionTabs = ot7_divisions.map((d) => [d.slug, d.name]);

	const tabs = [playoffsTab, powerRankingsTab, ...divisionTabs];
	// const tabs = [powerRankings];

	return (
		<PageHeader tabs={tabs} tabRoot={'/standings'} ctaText="Teams" ctaUrl="/teams">
			Standings
		</PageHeader>
	);
};

const Standings = () => {
	let { phase, section: divisionSlug } = useParams();

	if (!divisionSlug) {
		// Default to playoffs if no division slug is provided
		divisionSlug = 'playoffs';
	}

	const fetchDivisions = useFetch<Ot7Division[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_divisions/v1/public`,
		key: 'ot7_divisions',
	});
	const divisions = fetchDivisions?.result.read();

	const fetchDivision = useFetch<Ot7Division>({
		url: `${Urls.RestApiBaseUrl}/ot7_divisions/v1/public/${divisionSlug}`,
		key: 'ot7_division',
	});
	const division = fetchDivision?.result.read();

	const isPlayoffs = divisionSlug === 'playoffs' && phase !== 'tournament';
	const isPlayoffsBrackets = divisionSlug === 'playoffs' && phase === 'tournament';
	const isPowerRankings = divisionSlug === 'power-rankings';
	const isDivision = !isPlayoffs && !isPlayoffsBrackets && !isPowerRankings;

	if (isDivision && !division) {
		return <NotFound />;
	}

	return (
		<Layout>
			<div className="Standings">
				<Header ot7_divisions={divisions} />
				<ContentContainer>
					{isPlayoffs && <Playoffs />}
					{isPlayoffsBrackets && <PlayoffsBracket />}

					{isPowerRankings && <PowerRankings />}

					{/* If the division slug is not 'power-rankings' or 'playoffs', show the division header */}
					{isDivision && (
						<>
							{divisionSlug && (
								<div className="Phase">
									<div className="Primary">
										{/* {phase === 'tournament' ? (
									'Tournament'
								) : ( */}
										<>
											<img src={`${Urls.OvertimeImagesBaseUrl}/${division.logo_path}`} />
											{division.name}
										</>
										{/* )} */}
									</div>
									<div className="Secondary">
										<div className="Location">
											<div className="City">Dallas, TX</div>
											<div className="Date">Mar 12 - Present</div>
										</div>
										{divisionSlug == 'golden-ticket' && (
											<div className="StandingsLink">
												{phase === 'tournament' ? (
													<a href={`/standings/${divisionSlug}`}>
														<img src={imgIconStandingsListSvg} />
														Standings
													</a>
												) : (
													<a href={`/standings/${divisionSlug}/tournament`}>
														<img src={imgIconStandingsBracketSvg} />
														Bracket
													</a>
												)}
											</div>
										)}
									</div>
								</div>
							)}

							{phase === 'tournament' ? (
								<>
									<GoldenTicketBracket />
								</>
							) : (
								<>
									<Table
										showTies={divisionSlug == 'golden-ticket' ? false : true}
										isGoldenTicket={divisionSlug == 'golden-ticket'}
									/>
									<div className="Footnotes">
										{divisionSlug != 'golden-ticket' && (
											<div className="Footnote">
												<div className="Icon">
													<FontAwesomeIcon icon={faTrophy} color={styles.COLOR.BRAND_PRIMARY} size="2x" />
												</div>
												<div className="Text">Denotes Division Champ</div>
											</div>
										)}

										{divisionSlug == 'golden-ticket' && (
											<div className="Footnote">
												<div className="Icon">
													<img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />
												</div>
												<div className="Text">Denotes Golden Ticket Winner</div>
											</div>
										)}
									</div>
								</>
							)}
						</>
					)}

					{/* {divisionSlug == 'golden-ticket' ? <GoldenTicketBracket /> : <Table />} */}
				</ContentContainer>
			</div>
		</Layout>
	);
};

export default Standings;
